import { useCallback, useEffect, useState } from 'react'
import { GetPlayerCoinHistoryGanamosResponse } from '../../Api/UserPanel/models'
import { getPlayerCoinHistoryGanamos } from '../../Api/UserPanel/UserPanel'


export const useGetPlayerCoinHistoryGanamos = ({ form, otherHierarchies = false }: { form: { name: string }, otherHierarchies?: boolean }) => {
    const [playerCoinHistory, setPlayerCoinHistory] = useState<GetPlayerCoinHistoryGanamosResponse | null>(null)
    const [loading, setLoading] = useState(false)

    const getCoinHistory = useCallback(async () => {
        setLoading(true)
        const response = await getPlayerCoinHistoryGanamos({ name: form?.name?.trim(), otherHierarchies: otherHierarchies ?? false })
        setPlayerCoinHistory(response)
        setLoading(false)
    }, [form?.name, otherHierarchies])

    useEffect(() => {
        if (!form?.name) return;
        getCoinHistory();
    }, [getCoinHistory, form?.name]);

    return {
        playerCoinHistory,
        loading,
        getCoinHistory,
    }

}
